var guardsTable;


function CreateGuardsTable(guardTerm) {

    guardsTable = jexcel(document.getElementById('guards'), {
        data: null,
        minDimensions: [2, 500],
        tableOverflow: true,
        columns: [
            {
                title: 'Name',
                type: 'string',
                width: '250px',
            },
            {
                title: 'Email',
                type: 'text',
                width: '300px',
            },
            {
                title: 'Phone number',
                type: 'text',
                width: '150px',
            },
            {
                title: guardTerm + ' number',
                type: 'text',
                width: '150px',
            },
            {
                title: 'Shift color',
                type: 'color',
                render: 'square',
                width: '150px',
            },
            {
                title: 'Plate number',
                type: 'text',
                width: '250px',
            },
        ],
        rowResize: true,
        columnDrag: true,
    });

    return 1;
}


function PopulateGuardsTable(guardsInDatabase) {
    var guards = [];

    try {
        guardsInDatabase.forEach(guard => guards.push([guard.guardName, guard.guardEmail, guard.guardPhonenumber, guard.guardNumber, guard.guardColorShift, guard.guardLicensePlate]))


        if (guardsTable != null) {
            guardsTable.setData(guards, false);
        } else {
        }
    } catch (e) {
        console.log("PopulateGuardsTable Error");
        console.log(e);
    }

    return 1;
}


function showGuardDuplicateError(guardTerm) {
    swal({
        title: guardTerm + " name must be unique",
        text: "\n" + "The " + guardTerm + " name must be unique. Verify there are no duplicates in the column 'Name'\n\nChanges have not been saved",
        type: "info"
    });
}

function initStaffColorPicker() {

    document.documentElement.style.setProperty('--toolbelt-loadingbar-color', 'transparent')

    $('#staffColorPicker').colorPicker({
        // default: true
        preview: true
    });

    return 1;
}

function setStaffColorPicker(col) {
    $('#staffColorPicker').css({
        backgroundColor: col
    });

    $('#staffColorPicker').val("");
}

function getStaffColorPickerValue() {
    var color = $('#staffColorPicker').css("background-color");
    return color;
}


function toggleNewStaffDialog(staffId) {
    $('#newStaffModal').modal('toggle');
    return 1;
}

function closeNewStaffDialog() {
    $('#newStaffModal').modal('hide');
    return 1;
}

function FileChosenStaffProfileImage(e, siteId, staffId, auth) {

    try {
        //var fileName = $('#staffImageUpload').prop('files')[0].name;

        var url = 'https://visitform.com/app/api/Image/staffprofile/';
        if (release == false) {
            url = 'https://localhost:5001/api/Image/staffprofile/';
        }
        // $('#upload').on('click', function () {
        var file_data = $('#staffImageUpload').prop('files')[0];
        console.log(file_data);
        var form_data = new FormData();
        form_data.append('file', file_data);
        $.ajax({
            url: url + siteId + '/' + staffId,
            dataType: 'text',
            cache: false,
            contentType: false,
            processData: false,
            data: form_data,
            type: 'post',
            beforeSend: function (xhr) {
                xhr.setRequestHeader("Authorization", 'Bearer ' + auth);

                $('#staffProfileImageSpinner').show();
            },
            success: function (response) {
                //  $('#msg').html(response); 
                setTimeout(function () {
                    $('#staffProfileImageSpinner').hide();
                    DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnStaffProfileImageUploadDone', staffId);
                    clearStaffProfilePictureInput();;
                }, 8000);
            },
            error: function (response) {
                //  $('#msg').html(response); 
                alert(response);
                $('#staffProfileImageSpinner').hide();
                clearStaffProfilePictureInput();
            }
        });
    } catch (e) {
        console.log(e);
    }
}

function StartProfileUpload() {
    $("#staffImageUpload").click();
}

function clearStaffProfilePictureInput() {
    clearInputFile(document.getElementById('staffImageUpload'));
}

function StartRemoveProfilePicture(staffId) {
    swal({
        title: "Are you sure? This can not be undone.",
        text: " ",
        showCancelButton: true,
        confirmButtonText: "Yes, remove.",
        confirmButtonClass: "btn-warning",
        cancelButtonText: "No",
        closeOnConfirm: true
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnRemoveStaffProfileImage', staffId);
        });
}

function StartDeleteStaff(staffId) {
    swal({
        title: "Are you sure? This cannot be undone.",
        text: " ",
        showCancelButton: true,
        confirmButtonText: "Yes, remove.",
        confirmButtonClass: "btn-warning",
        animation: "slide-from-top",
        customClass: "swal-overylay-modal-force",
        cancelButtonText: "No",
        closeOnConfirm: true
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnRemoveStaff', staffId);
        });
}

function showStaffDuplicateError() {
    swal({
        title: "Name must be unique",
        text: "\nThe staff name must be unique. Verify there are no duplicates.\n\nChanges have not been saved",
        type: "info"
    });
}